import asyncActionTypes from '../../actions/types.js';
import tripTypes from '../../../scripts/constants/trip-types-enum.js';

const initialState = {
  airportsList: [],
  airportsListFiltered: [],
  destinationAirport: {},
  originAirport: {},
  tripType: tripTypes.ROUND_TRIP,
  passengersData: {
    ADULT: 1,
    CHILD: 0,
    INFANT: 0,
  },
};

const booker = (state = initialState, action) => {
  switch (action.type) {
    case asyncActionTypes.CHANGE_TRIP_TYPE:
      return {
        ...state,
        tripType: action.tripType,
      };
    case asyncActionTypes.CHANGE_AIRPORTS_LIST:
      return {
        ...state,
        airportsList: action.airportsList,
      };
    case asyncActionTypes.CHANGE_ORIGIN_AIRPORT:
      return {
        ...state,
        originAirport: action.originAirport,
      };
    case asyncActionTypes.CHANGE_DESTINATION_AIRPORT:
      return {
        ...state,
        destinationAirport: action.destinationAirport,
      };
    case asyncActionTypes.CHANGE_AIRPORTS_LIST_FILTERED:
      return {
        ...state,
        airportsListFiltered: action.airportsListFiltered,
      };
    case asyncActionTypes.CHANGE_PASSENGER_COUNT:
      return {
        ...state,
        passengersData: action.passengersData,
      };
    default:
      return state;
  }
};

export default booker;